(ns app.front.view.licence.view
  (:require [app.domain.application.model :as app-model]
            [app.domain.business.model :as business-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.actions :as ui-actions]
            [app.front.ui.section :as section]
            [app.front.ui.termination-info :as termination-info]
            [app.front.util :as futil]
            [app.front.view.common.applications-section :as app-section]
            [app.front.view.common.generic-licence :as gl-view]
            [app.front.view.inspections.summary-subsection :as inspections-summary-subsection]
            [app.front.view.letter.section :as letter-section]
            [app.front.view.licence.header :as licence-header]
            [app.front.view.licence.subs :as licence-subs]
            [app.front.view.workspace.util :as ws-util]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]))

(defn make-inspections-subsection-props [{workspace-id  :workspace/id
                                          permit-number :workspace/municipal-case-id
                                          :as           workspace}]
  (let [lang (<sub [:language])
        tr   (<sub [:tr])]
    {:title    (cc/link {:href       (ws-util/workspace-or-resume-application-href workspace)
                         :class-name "font-bold"}
                        (or permit-number workspace-id))
     :subtitle (futil/str-and-desc
                 (tr [(:workspace/permit-type workspace)])
                 (-> workspace
                     workspace-model/workspace-application
                     (app-model/work-type-name lang)))}))

(defn inspections-section [tr current-licence]
  [section/section
   :inspections
   {:tr             tr
    :heading-button [ui-actions/primary-signal-button
                     (util/mmap {:signal-id   :process.signal/create-supplemental-workspace
                                 :target-id   (:db/id current-licence)
                                 :process-sub [::licence-subs/current-licence-process]
                                 :button-opts {:kind :ghost}}
                                tr)]}
   (tr [:licence/inspections])
   [inspections-summary-subsection/inspections
    (util/mmap {:workspaces-sub        [::licence-subs/current-workspaces]
                :make-subsection-props make-inspections-subsection-props}
               tr)]])


(defn view [_]
  (let [tr              (<sub [::licence-subs/tr])
        current-licence (<sub [::licence-subs/licence])]
    [:div.cloudpermit-page
     (if current-licence
       [licence-header/header tr current-licence]
       (cc/skeleton-text))
     [gl-view/renewal-box
      {:entity              current-licence
       :expired-state       :licence.state/expired
       :primary-signal-opts {:signal-id   :process.signal/renew-licence
                             :process-sub [::licence-subs/current-licence-process]
                             :button-opts {:kind    :tertiary
                                           :data-cy "renew-licence-button"}}
       :tr                  tr}]
     (when (du/in-state? :licence.state/revoked current-licence)
       [termination-info/termination-info
        current-licence
        (util/mmap {:reason-attr  :licence/revocation-reason
                    :by-attr      :licence/revocation-by
                    :ts-attr      :licence/revocation-ts
                    :descr-tr-key :rejection/by} tr)])
     [inspections-section tr current-licence]
     [app-section/applications tr (:licence/workspaces current-licence)]
     [letter-section/letters-section (util/mmap {:target-id (:db/id current-licence)} tr)]]))

(defn breadcrumb-business [_]
  (let [lang       (<sub [:language])
        licence-id (<sub [::licence-subs/licence-entity-id])
        issued-to  (<sub [::licence-subs/issued-to licence-id])]
    (when (eu/is-type? :entity.type/business issued-to)
      (let [business-name (business-model/format-name issued-to lang)]
        [:view/business {:business-id (:db/id issued-to)} business-name]))))

(defn breadcrumb-licence [{:keys [match]}]
  (let [params     (-> match :parameters :path)
        licence-id (-> (<sub [::licence-subs/licence]) :licence/id)]
    (when licence-id
      [:view/licence params licence-id])))

(def route
  {:name        :view/licence
   :view        view
   :view-sub    [::licence-subs/view-data]
   :breadcrumb  {:items [breadcrumb-business
                         breadcrumb-licence]}
   :controllers [{:parameters {:path [:group-id :licence-id]}
                  :start      (fn [{{:keys [group-id licence-id]} :path}]
                                (>evt [::licence-subs/fetch-licence group-id licence-id]))}]})
